/**
 * @description Component-ScaleFormDetail
 */
import { WrappedPair } from '@/entities/WrappedPair';
import './index.less';

import { useTradeStoreTransformed } from '@/features/trade/hooks';
import { useSimulateBatchPlaceScaledLimitOrder } from '@/features/trade/query';
import { useChainId } from '@/hooks/web3/useChain';
import { toBN } from '@/utils/numberUtil';
import { Side } from '@synfutures/sdks-perp';
import { FC } from 'react';
import { LimitFormDetail } from '../TradeLimitForm/LimitFormDetail';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
  currentPair?: WrappedPair;
  tradeSide: Side;
}
const ScaleFormDetail: FC<IPropTypes> = function ({ currentPair, tradeSide }) {
  const chainId = useChainId();
  const { tradeSize } = useTradeStoreTransformed();
  const { data: scaleSimulation } = useSimulateBatchPlaceScaledLimitOrder(chainId);
  return (
    <>
      {toBN(tradeSize || 0).gt(0) && (
        <LimitFormDetail
          marginToken={currentPair?.rootInstrument.marginToken}
          fairPrice={currentPair?.wrapAttribute('fairPrice')}
          isLoading={false}
          chainId={chainId}
          pairSymbol={currentPair?.symbol}
          tradeSide={tradeSide}
          simulationData={scaleSimulation?.data}
        />
      )}
    </>
  );
};

export default ScaleFormDetail;
